import { Module } from 'vuex';
import { NodeOtherAccountState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeOtherAccountState = {
    otherAccounts: undefined,
    otherAccountCount: 0,
    otherAccountDetails: {
        account: undefined,
        node: undefined,
    },
    wkOtherAccounts: undefined,
    wkOtherAccountCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const nodeOtherAccount: Module<NodeOtherAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
